var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "face-recognition"
  }, [_c("section", {
    style: {
      background: `url(${_vm.bannerUrl}) no-repeat center 0px`,
      backgroundSize: "cover"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.bannerUrl,
      title: _vm.bannerTitle,
      description: _vm.bannerText
    }
  })], 1), _c("Function", {
    attrs: {
      title: "产品功能",
      adslist: _vm.functionList
    }
  }), _c("section", {
    staticClass: "application"
  }, [_c("div", {
    staticClass: "application_main"
  }, [_c("Title", {
    attrs: {
      title: "应用场景"
    }
  }), _c("div", {
    staticClass: "application_main_card"
  }, _vm._l(_vm.businessList, function (item, index) {
    return _c("BusiCard", {
      key: index,
      attrs: {
        title: item.title,
        desc: item.desc,
        img: item.img
      }
    });
  }), 1)], 1)]), _c("section", {
    staticClass: "advantages"
  }, [_c("div", {
    staticClass: "ads-main"
  }, [_c("Title", {
    staticClass: "title",
    attrs: {
      title: "产品优势"
    }
  }), _c("Advantages2", {
    attrs: {
      leftItems: _vm.leftItems,
      rightItems: _vm.rightItems
    }
  })], 1)]), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };